import getGlobalConfig from "../globalConfig";

export function getAuthConfig() {

  const config = getGlobalConfig().auth
  const audience = config.audience;

  return {
    domain: config.domain,
    clientId: config.clientId,
    scope: config.scope,
    redirectUri: config.redirectUri,
    ...(audience ? { audience } : null),
  };
}